import React from 'react'
import PaymentMethodLogo from './PaymentMethodLogo'
import styles from './styles.module.css'
import {
  PAYMENT_METHOD_VISA_ID,
  PAYMENT_METHOD_MASTERCARD_ID,
  PAYMENT_METHOD_AMEX_ID,
} from '../PaymentForm/constants'
import { useMarket } from 'src/hooks/useMarket'

interface Props {
  apm?: string
  creditCard?: boolean
  applePay?: boolean
  checkout?: boolean
  width?: number
  height?: number
}

const PaymentMethodsLogos = ({
  creditCard = false,
  checkout = false,
  apm,
  applePay = false,
  width,
  height,
}: Props) => {
  const { overrideCreditCardLogos } = useMarket()

  const defaultPaymentMethods = [
    PAYMENT_METHOD_VISA_ID,
    PAYMENT_METHOD_MASTERCARD_ID,
    PAYMENT_METHOD_AMEX_ID,
  ]

  const paymentMethods = overrideCreditCardLogos || defaultPaymentMethods

  return (
    <div className={styles.logosContainer} data-testid="payment-logos">
      {checkout &&
        paymentMethods.map((paymentMethod: string) => (
          <PaymentMethodLogo id={paymentMethod} key={paymentMethod} />
        ))}
      {creditCard && <PaymentMethodLogo id="creditcard" />}
      {apm === 'giropay' && <PaymentMethodLogo id={apm} width={width ?? 34} height={width ?? 24} />}
      {apm === 'klarna' && (
        <PaymentMethodLogo withoutBorder width={width ?? 39} height={width ?? 24} id={apm} />
      )}
      {apm === 'ideal' && <PaymentMethodLogo id={apm} />}
      {apm === 'multibanco' && <PaymentMethodLogo id={apm} />}
      {apm === 'bancontact' && <PaymentMethodLogo id={apm} />}
      {applePay && (
        <PaymentMethodLogo withoutBorder width={width ?? 39} height={height ?? 26} id="applepay" />
      )}
    </div>
  )
}

export default PaymentMethodsLogos
